import axios from './axios'

function mine() {
    return axios.get('tenants/mine').then(response => response.data).catch(e => { throw e })
}

function setCurrent(tenantId) {
    return axios.post(`tenants/${tenantId}/set-current`).then(response => response.data).catch(e => { throw e })
}

/** Kilépés a belépett intézményből (csak a platform-szintű felhasználónak van honnan). */
function leave() {
    return axios.post('tenants/leave').then(response => response.data).catch(e => { throw e })
}

/** Írás bekapcsolása a belépett intézményben, indokkal és időkorláttal. */
function enableWrite(reason, minutes) {
    return axios.post('tenants/write-access', {reason, minutes}).then(response => response.data).catch(e => { throw e })
}

/** Írás kikapcsolása: vissza a csak-olvasáshoz. */
function disableWrite() {
    return axios.delete('tenants/write-access').then(response => response.data).catch(e => { throw e })
}

/** Belépve a nézet: global (a platform elemei is) vagy institution (pontosan az intézmény nézete). */
function setView(view) {
    return axios.put('tenants/view', {view}).then(response => response.data).catch(e => { throw e })
}

function setActive(tenantId, isActive) {
    return axios.patch(`tenants/${tenantId}/active`, {is_active: isActive}).then(response => response.data).catch(e => { throw e })
}

export default {
    mine,
    setCurrent,
    leave,
    enableWrite,
    disableWrite,
    setView,
    setActive,
}
